<div class="d-flex flex-column align-items-center justify-content-center full-height gauge-desc-container" [ngClass]="{'title-on-top': isTitleOnTop}">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <span class="platform-reach-data-label"
          placement="top" ngbTooltip="{{tooltipInfo}}"
          [ngClass]="{'platform-reach-data-label-cf': isChannelFollower}">
      {{reachValue | thousandNumberSuffix}}
    </span>
    <span *ngIf="reachLabel" class="reach-label">{{reachLabel}}</span>
    <div class="d-flex flex-row platform-reach-sub-label" [ngClass]="{'platform-reach-sub-label-cf': isChannelFollower}">
      <div *ngIf="hasAscendingStatus(reachStatus)" class="asc-icon-wrapper">
        <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <desc></desc>
          <defs>
            <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
          </defs>
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Keyicons/Chevron-up">
              <g id="Chevron-down">
                <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <use *ngIf="!isChannelFollower" id="Mask" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                <use *ngIf="isChannelFollower" id="Mask" fill="#54D89F" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div *ngIf="hasDescendingStatus(reachStatus)" class="desc-icon-wrapper">
        <svg width="6px" height="6px" viewBox="0 0 8 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
          </defs>
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Keyicons/Chevron-down" transform="translate(-6.000000, -8.000000)">
              <g id="Chevron-down">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <use *ngIf="!isChannelFollower" id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
                <use *ngIf="isChannelFollower" id="Mask" fill="#EC506E" fill-rule="nonzero" xlink:href="#path-1"></use>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <span [ngClass]="{'platform-reach-data-sublabel-asc': hasAscendingStatus(reachStatus),
                            'platform-reach-data-sublabel-desc': hasDescendingStatus(reachStatus)}">
            {{reachPercent | percentNumberSuffix}}
          </span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-gauge-circle-chart-content/achoo-gauge-circle-chart-content.component.html